import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TooltipEllipsifyDirective } from './tooltip-ellipsify.directive';



@NgModule({
  declarations: [TooltipEllipsifyDirective],
  imports: [
    CommonModule,
    TooltipModule.forRoot(),
  ],
  exports: [TooltipEllipsifyDirective],
})
export class TooltipEllipsifyModule { }